enum DocumentTypeEnum {
    GENERAL_DOCUMENT = 'general_document',
    CONTRACT_AMENDMENT = 'contract_amendment',
    TERMINATION = 'termination',
    LEGISLATIVE_DOCUMENT = 'legislative_document',
    INTERNAL_COMMUNICATION = 'internal_communication',
    ADMINISTRATIVE_DOCUMENT = 'administrative_document',
    ADVISORY_DOCUMENT = 'advisory_document',
    OFFICIAL_DOCUMENT = 'official_document',
    EXTERNAL_DEMAND = 'external_demand',
    CIRCULAR = 'circular',
}

export const documentTypeTranslations: Record<DocumentTypeEnum, string> = {
  [DocumentTypeEnum.GENERAL_DOCUMENT]: 'Documento Geral',
  [DocumentTypeEnum.CONTRACT_AMENDMENT]: 'Contratos e Aditivos',
  [DocumentTypeEnum.TERMINATION]: 'Rescisão',
  [DocumentTypeEnum.LEGISLATIVE_DOCUMENT]: 'Documentos Legislativos',
  [DocumentTypeEnum.INTERNAL_COMMUNICATION]: 'Documentos de Comunicação Interna',
  [DocumentTypeEnum.ADMINISTRATIVE_DOCUMENT]: 'Documentos Administrativos',
  [DocumentTypeEnum.ADVISORY_DOCUMENT]: 'Documentos de Assessoria',
  [DocumentTypeEnum.OFFICIAL_DOCUMENT]: 'Documentos Oficiais',
  [DocumentTypeEnum.EXTERNAL_DEMAND]: 'Demandas Externas (encaminhadas entre gabinetes)',
  [DocumentTypeEnum.CIRCULAR]: 'Circular',
}

export default DocumentTypeEnum
